import { type FC } from 'react';

import type { AcquiringType, PaymentType } from 'types/payment';
import { acquiringIconType, twMergeClsx } from 'utils';

type AcquiringsRadioBtnPropTypes = {
  paymentData: PaymentType | null;
  acquiringsItem: AcquiringType;
  checked: boolean;
};

const AcquiringsRadioBtn: FC<AcquiringsRadioBtnPropTypes> = ({
  checked,
  paymentData,
  acquiringsItem,
}) => {
  return (
    <div
      className={twMergeClsx(
        'border rounded-xsmall items-center w-full flex gap-2 py-[10px] px-4 border-base-gray-900 h-[44px]',
        checked && 'border-base-blue-100',
      )}
    >
      <div>
        {checked ? (
          <div className="rounded-full bg-radio-check-icon bg-center bg-no-repeat bg-contain w-4 h-4" />
        ) : (
          <div className="w-4 h-4 rounded-full border-[2px] border-base-gray-600" />
        )}
      </div>
      <span className="flex-grow text-[12px] leading-140">{acquiringsItem.title}</span>
      <div>
        {paymentData && (
          <img
            src={acquiringIconType(paymentData.paymentType, acquiringsItem.formType)}
            className="h-5"
            alt="logo"
          />
        )}
      </div>
    </div>
  );
};

export { AcquiringsRadioBtn };
